export const getSessionIdentity = () => {
  try {
    const authToken = localStorage.getItem("DfsWeb.access-token");
    const raw = localStorage.getItem("DfsWeb.user-info");
    if (!authToken || !raw) return null;

    const info = JSON.parse(raw);
    if (!info?.uuid) return null;

    return { uuid: info.uuid, authToken, tenantId: info.tenantId || "br" };
  } catch (e) {
    return null;
  }
};
